import React, { Component } from 'react';
import { Box, Container, Typography } from '@mui/material';
import './about.css';
import { Scrollbars } from 'rc-scrollbars';
// News data array
const newsData = [
    {
        date: "2026.01",
        items: [
            'Our paper "LLM-based In-situ Thought Exchanges for Critical Paper Reading" was conditionally accepted to IUI \'26.'
        ]
    },
    {
        date: "2025.10",
        items: [
            'I joined the AI Safety and Reliability Unit at RIKEN Center for Advanced Intelligence Project (AIP) as a Special Postdoctoral Researcher!',
            'I will present my position paper "Privacy Perception and Protection in Continuous Vision-Language Models Interaction" at the HAIPS workshop at CCS \'25 in Taipei.',
        ]
    },
    {
        date: "2025.09",
        items: [
            'I graduated from The University of Tokyo with a Ph.D. and received an Excellent Dissertation Award!',
        ]
    },
    {
        date: "2025.04",
        items: [
            'I am going to attend the CHI \'25 Conference. I am looking forward to chatting with all researchers.',
            'I am a co-author of the CHI \'25 late-breaking work paper "Exploring Practices, Challenges, and Design Implications for Citation Foraging, Management, and Synthesis," in collaboration with Xinrui Fang, Sylvain Malacria, and Koji Yatani.'
        ]
    }
    ,
    {
        date: "2024.10",
        items: [
            'My IMWUT (UbiComp \'24) paper received a Distinguished Paper Award (8 of 205 published papers)!',
            'I am going to present my IMWUT (UbiComp \'24) paper "DIPA2: An Image Dataset with Cross-cultural Privacy Perception Annotations." I look forward to discussing privacy perceptions across cultures in Melbourne, Australia, in October!'
        ]
    },
    {
        date: "2024.8",
        items: [
            'I visited CyLab at Carnegie Mellon University in Pittsburgh and presented my research on image privacy protection at SOUPS in Philadelphia.'
        ]
    },
    {
        date: "2024.6",
        items: [
            'My poster for SOUPS 2024 was accepted. I look forward to discussing research ideas in usable security in Philadelphia in August!'
        ]
    },
    {
        date: "2024.5",
        items: [
            "I attended CHI 2024 and presented my paper \"Examining Human Perception of Generative Content Replacement in Image Privacy Protection\" in Hawaii.",
        ]
    },
    {
        date: "2024.4",
        items: [
            "I received a Google Conference Scholarship to attend CHI 2024."
        ]
    },
    {
        date: "2024.2",
        items: [
            "My CHI 2024 paper \"Examining Human Perception of Generative Content Replacement in Image Privacy Protection\" was accepted. In this work, we developed a novel image privacy protection method called \"generative content replacement (GCR)\" and investigated how people perceive it."
        ]
    },
    {
        date: "2023.11",
        items: [
            "My IMWUT (UbiComp '24) paper \"DIPA2: An Image Dataset with Cross-cultural Privacy Perception Annotations\" was accepted. This paper extends our IUI '23 work with additional human-centered privacy metrics and examines how human factors influence privacy perception."
        ]
    },
    {
        date: "2023.10",
        items: [
            "I delivered talks on image privacy protection at the University of Oulu and the University of Lapland in Finland."
        ]
    },
    {
        date: "2023.3",
        items: [
            "I published and presented my short paper \"DIPA: An Image Dataset with Cross-cultural Privacy Concern Annotations\" at IUI '23 in Sydney.",
            "I participated in a Microsoft Research Asia D-CORE collaborative research project with Huan Yang.",
            "I received a Gary Marsden Travel Award from SIGCHI to attend IUI 2023."
        ]
    },
	{
        date: "2022.10",
        items: [
            "I started my Ph.D. program at The University of Tokyo!"
        ]
    }
];

class About extends Component {
    
	renderNews = () => (
        newsData.map((newsEntry, index) => (
            <Box key={index} sx={{ mb: 2 }}>
                <Typography variant="h6">{newsEntry.date}:</Typography>
                {newsEntry.items.map((item, subIndex) => (
                    <Typography key={subIndex} paragraph>{item}</Typography>
                ))}
            </Box>
        ))
    );

    render (){
    return(
        <div className='aboutMain'>
            {this.props.show ? (
            <Container sx={window.innerWidth > this.props.xlBoundary ? { mt: 4, mb: 4, ml: 4, mr: 4} : {mt: 4}}>
                <Box>
                    <Typography variant="h4" gutterBottom>About Me</Typography>
                    <Typography paragraph sx={{ fontSize: '1.1rem' }}>
                        I am a Special Postdoctoral Researcher (SPDR) in the <a href="https://www.riken.jp/en/research/labs/aip/ai_soc/ai_saf_rely/index.html" target="_blank" rel="noopener noreferrer">AI Safety and Reliability Unit</a> at RIKEN, working with Unit Leader Hiromi Arai. I received my Ph.D. from The University of Tokyo under the supervision of Prof. Koji Yatani and my B.S. from Peking University under the supervision of Prof. Huijing Zhao.
                    </Typography>
                    <Typography paragraph sx={{ fontSize: '1.1rem' }}>
                        My current research focuses on understanding privacy issues that arise when people interact with vision-language models, especially in <a href="https://doi.org/10.1145/3733816.3760749" target="_blank" rel="noopener noreferrer">continuous interaction scenarios</a>, and on designing novel methods to mitigate these risks.
                    </Typography>
                    <Typography paragraph sx={{ fontSize: '1.1rem' }}>
                        My Ph.D. research focused on helping people share photos more safely through novel image protection methods, such as <a href="https://dl.acm.org/doi/10.1145/3613904.3642103" target="_blank" rel="noopener noreferrer">Generative Content Replacement (GCR)</a>. I also developed a publicly available dataset called <a href="https://anranxu.github.io/DIPA2_VIS/" target="_blank" rel="noopener noreferrer">DIPA2</a> for investigating context-dependent privacy concerns in photos.
                    </Typography>
                    <Typography paragraph sx={{ fontSize: '1.1rem' }}>
                        My research interests include <strong>Human-Computer Interaction</strong> (HCI), <strong>Usable Security</strong>, <strong>Computer Vision</strong> (CV), and <strong>Machine Learning</strong> (ML). I am particularly interested in combining these technologies with HCI theories to make AI and security tools more accessible to non-expert users.
                    </Typography>
                    <Typography paragraph sx={{ fontSize: '1.1rem' }}>
                        Please feel free to contact me (<a href="mailto:anran.xu@riken.jp">anran.xu@riken.jp</a> or <a href="mailto:anranxu98@gmail.com">anranxu98@gmail.com</a>) if you would like to work with me.
                    </Typography>
                </Box>
                <Box>
                    <Typography variant="h4" gutterBottom>News</Typography>
                    {   window.innerWidth > this.props.xlBoundary ?
                        <Scrollbars style={{ height: document.documentElement.clientHeight * 2/3 }}>
                            {this.renderNews(newsData)}
                        </Scrollbars>:
                        this.renderNews(newsData)
                    }
                </Box>
            </Container>
            ):null}
            </div>
    );
}
}

export default About;
